export const commonStatusOptions = [
    {text: 'All', value: null},
    {text: 'Open', value: 1},
    {text: 'Close', value: 0},
]

export const booleanStatusOptions = [
    {text: 'All', value: null},
    {text: 'Yes', value: 1},
    {text: 'No', value: 0},
]

export const todoTypeOptions = [
    {text: 'All', value: null},
    {value: 'message', text: 'Message'},
    {value: 'workflow', text: 'Workflow'},
]

export const todoSourceOptions = [
    {text: '全部', value: null},
]

export const quotationStatusOptions = [
    {text: 'All', value: null},
    {text: 'Open', value: 0},
    {text: 'Pending', value: 10},
    {text: 'Confirmed', value: 20},
    {text: 'Approved', value: 30},
]

export const customerQuotationStatusOptions = [
    {text: 'All', value: null},
    {text: 'Open', value: 0},
    {text: 'Confirmed', value: 10},
]

export const programOptions = [
    {text: 'All', value: null},
    {text: 'Motion', value: 'Motion'},
    {text: 'Stationary', value: 'Stationary'},
    {text: 'Brand X', value: 'Brand X'},
    {text: 'Leather Republic', value: 'Leather Republic'},
]

